export enum TextNodeType {
  paragraph = 'paragraph',
  heading1 = 'heading1',
  heading2 = 'heading2',
  heading3 = 'heading3',
  heading4 = 'heading4',
  heading5 = 'heading5',
  heading6 = 'heading6',
}

export interface TextSpan {
  start: number;
  end: number;
  type: keyof JSX.IntrinsicElements;
}

export interface TextNode {
  type: TextNodeType;
  text: string;
  spans?: TextSpan[];
}
